/*==========================================
=            Trip Planner Store            =
==========================================*/

// imports
import settings from '../../config/index'
import utils from '../../helpers/utils'
import { modeIcons } from '../../helpers/common'
import VueScrollTo from 'vue-scrollto'


// check we have moment as a global and configure time zone!
if (!window.moment) { console.log('!!moment not defined!') }
window.moment.tz.add(settings.DATETIME.MOMENT_TIME_ZONE)
window.moment.tz.setDefault(settings.DATETIME.TIME_ZONE)

// Store, this is the single source of truth that powers the application
const state = {
  inputs   : {
    origin: {
      name: '',
      lat : '',
      lng : '',
      type: '',
    },
    destination: {
      name: '',
      lat : '',
      lng : '',
      type: '',
    },
    when: {
      type     : 'now',
      date     : window.moment().format('YYYY-MM-DD'), // iso8601
      time     : window.moment().format('HH:mm'), // iso8601
      time_zone: settings.DATETIME.TIME_ZONE,
    },
    options: {
      alternatives: true,
      optimize: 'QUICK',
      units: 'imperial',
      transit_routing_preference: 'best_route',
      mode: null, // driving, walking, bicycling or transit.
      transit_mode: null // bus, subway, train, tram or rail. Rail is transit_mode=train|tram|subway
    },
  },
  router: {
    params: {},
    query: {},
  },
  resultsFuture  : {
    selectedTripIndex   : -1,
    selectedLegIndex    : -1,
    selectedLegIsLast   : false, // show selected leg's finish point, if false show leg's start location
    setMapBounds        : false,
    meta                : {},
    summary             : {},
    data                : {},
    routes              : [],
  },
  resultsCurrent  : {
    selectedTripIndex   : -1,
    selectedLegIndex    : -1,
    selectedLegIsLast   : false, // show selected leg's finish point, if false show leg's start location
    setMapBounds        : false,
    meta                : {},
    summary             : {},
    data                : {},
    routes              : [],
  },
  ajax: {
    loading: false
  },
  currentTripData: {},
  futureTripData: {},
  compareFutureCurrent: false,
  resultsViewActive: 'future'
}

// make blank copy of results for current trips, default state is for future trips
// state.currentResults = JSON.parse(JSON.stringify(state.results))

// create base clone of state
const stateBase = JSON.parse(JSON.stringify(state)) // NOTE Object.assign does not do deep nested cloning!

// mutations calls are sync operations and are the only place that the store can be updated.
const mutations = {
  SET_INPUT_ORIGIN (state, payload) {
    state.inputs.origin = payload
  },
  SET_INPUT_DESTINATION (state, payload) {
    state.inputs.destination = payload
  },
  SET_INPUT_ORIGIN_NAME (state, payload) {
    state.inputs.origin.name = payload
  },
  SET_INPUT_DESTINATION_NAME (state, payload) {
    state.inputs.destination.name = payload
  },
  SET_INPUT_ORIGIN_LOCATION (state, payload) {
    state.inputs.origin.lat = payload.lat
    state.inputs.origin.lng = payload.lng
  },
  SET_INPUT_DESTINATION_LOCATION (state, payload) {
    state.inputs.destination.lat = payload.lat
    state.inputs.destination.lng = payload.lng
  },
  SET_INPUT_DATE (state, payload) {
    state.inputs.when.date = payload
  },
  SET_INPUT_TIME (state, payload) {
    state.inputs.when.time = payload
  },
  SET_INPUT_DEPART_ARRIVE (state, payload) {
    state.inputs.when.type = payload
  },
  SET_AJAX_LOADING (state, bool) {
    state.ajax.loading = bool
  },
  SET_URL_PARAMS (state, payload) {
    state.inputs.url_params = payload
  },
  SET_URL_QUERY (state, payload) {
    state.inputs.url_query = payload
  },
  SET_TRIP_OPTIONS (state, payload) {
    state.inputs.options = payload
  },
  SET_FUTURE_TRIP_RESULTS_META (state, payload) {
    state.resultsFuture.meta = payload
  },
  SET_CURRENT_TRIP_RESULTS_META (state, payload) {
    state.resultsCurrent.meta = payload
  },
  SET_FUTURE_TRIP_RESULTS_SUMMARY (state, payload) {
    state.resultsFuture.summary = payload
  },
  SET_CURRENT_TRIP_RESULTS_SUMMARY (state, payload) {
    state.resultsCurrent.summary = payload
  },
  SET_FUTURE_TRIP_RESULTS_ROUTES (state, payload) {
    state.resultsFuture.routes = payload
  },
  SET_CURRENT_TRIP_RESULTS_ROUTES (state, payload) {
    state.resultsCurrent.routes = payload
  },

  // SET_TRIP_RESULTS_DATA (state, payload) {
  //   state[(resultsViewActive === 'current') ? 'resultsCurrent' : 'resultsFuture'].data = payload
  // },
  SET_SELECTED_TRIP_INDEX (state, num) {
    // state.results.selectedTripIndex = num
    state[(state.resultsViewActive === 'current') ? 'resultsCurrent' : 'resultsFuture'].selectedTripIndex = num
  },
  SET_SELECTED_LEG_INDEX (state, num) {
    state[(state.resultsViewActive === 'current') ? 'resultsCurrent' : 'resultsFuture'].selectedLegIndex = num
  },
  SET_SELECTED_LEG_IS_LAST (state, bool) {
    state[(state.resultsViewActive === 'current') ? 'resultsCurrent' : 'resultsFuture'].selectedLegIsLast = bool
  },
  SET_CURRENT_RESULTS_VIEW (state, payload) {
    state.resultsViewActive = payload
  },
  RESET_INPUTS (state) {
    state.inputs.origin           = {name: '', lat: '', lng: ''}
    state.inputs.destination      = {name: '', lat: '', lng: ''}
    state.inputs.when.date = window.moment().format('YYYY-MM-DD')
    state.inputs.when.time = window.moment().format('HH:mm')
    // state.results.setMapBounds    = false
  },
  RESET_RESULTS (state) {
    state.resultsFuture = stateBase.resultsFuture
    state.resultsCurrent = stateBase.resultsCurrent
  },
  RESET (state) {
    let stateBaseCopy = JSON.parse(JSON.stringify(stateBase))
    state.inputs  = stateBaseCopy.inputs
    state.router  = stateBaseCopy.router
    // state.results  = stateBaseCopy.results
    state.resultsFuture  = stateBaseCopy.resultsFuture
    state.resultsCurrent  = stateBaseCopy.resultsCurrent
    state.currentTripData  = stateBaseCopy.currentTripData
    state.futureTripData  = stateBaseCopy.futureTripData
    state.compareFutureCurrent  = stateBaseCopy.compareFutureCurrent
    // console.log("RESET...", stateBaseCopy, state)
  } ,
  SET_CURRENT_TRIP_DATA (state, json) {
    state.currentTripData = json
  },
  SET_FUTURE_TRIP_DATA (state, json) {
    state.futureTripData = json
  },
  SET_COMPARE_FUTURE_CURRENT (state, bool) {
    state.compareFutureCurrent = bool
  }
}

// For async operations use actions, used mostly with ajax calls
const actions = {

  // for OTP get trips
  getTripsOTP ({ commit, state }, current = false ) {
    let options = getTripsOTPOptions(state)
    console.log("getTripsOTP", options, current)

    // set loading
    commit('SET_AJAX_LOADING', true)

    // remove errors
    commit((current) ? 'SET_CURRENT_TRIP_RESULTS_SUMMARY' : 'SET_FUTURE_TRIP_RESULTS_SUMMARY', { })

    // These should be set in env as well
    let apiUrlBaseFuture = '//sites.sdg-hosting.com/proxy/?path=https://otp.vta.org/otp/routers/default/plan'
    let apiUrlBaseCurrent = '//sites.sdg-hosting.com/proxy/?path=https://tripplanner.vta.org/api/otp/plan'
    // let apiUrl = (current) ? apiUrlBaseCurrent : apiUrlBaseFuture
    // let apiUrl = 'https://otp.vta.org/otp/routers/default/plan'
    // let apiUrl = 'https://otp.vta.org/otp/routers/default/plan'
    let apiUrl = 'https://tripplanner.vta.org/api/otp/plan'
    // let apiUrl = 'http://nextotp.vta.org:8888/otp/routers/default/plan'

    let jqXHR = jQuery.getJSON(apiUrl, options, (json) => {
      console.log('getTripsOTP got response', 'current:', current, json)
      if (current) {
        commit('SET_CURRENT_TRIP_DATA', json)
      } else {
        commit('SET_FUTURE_TRIP_DATA', json)
      }

      if (json.error) {
        commit((current) ? 'SET_CURRENT_TRIP_RESULTS_SUMMARY' : 'SET_FUTURE_TRIP_RESULTS_SUMMARY', {
            errors: true,
            message: json.error.msg,
          })
        return
      }
      commit((current) ? 'SET_CURRENT_TRIP_RESULTS_SUMMARY' : 'SET_FUTURE_TRIP_RESULTS_SUMMARY', {
          from: json.plan.from,
          to: json.plan.to,
          datestamp: json.plan.date,
          requestParameters: json.requestParameters,
          debugOutput: json.debugOutput,
          elevationMetadata: json.elevationMetadata,
          requestParameters: json.requestParameters,
        })

      // add mode icons and showSteps property
      json.plan.itineraries.forEach((route, routeIndex) => {
        json.plan.itineraries[routeIndex].walk_duration = { text: '-', value: 0 }
        route.legs.forEach((leg, legIndex) => {
          if (leg.mode === 'WALK'){
            json.plan.itineraries[routeIndex].walk_duration.value = parseInt(json.plan.itineraries[routeIndex].walk_duration.value) + parseInt(leg.duration)
          }
          json.plan.itineraries[routeIndex].legs[legIndex].modeIcon = modeIcons.find(mode => mode.otpKey === leg.mode)
          json.plan.itineraries[routeIndex].legs[legIndex].showSteps = false
        })
      })
      commit((current) ? 'SET_CURRENT_TRIP_RESULTS_ROUTES' : 'SET_FUTURE_TRIP_RESULTS_ROUTES', json.plan.itineraries)

      VueScrollTo.scrollTo('#trip-results', 750)

      // if (json.plan.itineraries.length > 0) {
      //   this.$router.push({
      //       name  : 'trip-planner-trip-details',
      //       params: Object.assign(this.router.params, {tripIndex: 0 }),
      //       query : this.router.query,
      //     });
      // }

    })
    .fail(function (jqXHR, textStatus, error) {
      console.log('"getTripsOTP" Request Failed: ' + textStatus + ', ' + error)
      commit((current) ? 'SET_CURRENT_TRIP_RESULTS_SUMMARY' : 'SET_FUTURE_TRIP_RESULTS_SUMMARY', {
          errors: true,
          message: json.error.msg,
        })
    })
    .always(function () {
      commit('SET_AJAX_LOADING', false)
      // console.log('getTripsOTP got response')
    })
    .progress(function(obj){
      console.log("PROGRESS", obj)
    })
    return jqXHR
  },

  // for Google Directions
  getDirectionsGoogle ({ commit, state }, options = getDirectionsGoogleOptions(state) ) {
    console.log("getDirections", options)

    // https://developers.google.com/maps/documentation/javascript/directions#DirectionsRequests
    VueGoogleMaps.loaded.then(()=>{
      let directionsService = new google.maps.DirectionsService;
      directionsService.route(options, (response, status) => {
                console.log(response)
                if (status === 'OK') {
                  commit('SET_TRIP_RESULTS_SUMMARY', {
                      status: response.status,
                      geocoded_waypoints: response.geocoded_waypoints,
                      request: response.request
                    })
                  // add walking time and mode icons for each trip
                  response.routes.forEach((r, rI) => {
                    r.legs.forEach((l, lI) => {

                      // add walking duration
                      let walkDuration = l.steps
                                          .filter(s => s.travel_mode === 'WALKING')
                                          .reduce((total, s) => total+s.duration.value, 0)
                      response.routes[rI].legs[lI].walk_duration = { text: utils.formatDuration(walkDuration), value: walkDuration }

                      let startTime = l.departure_time.value // Date object
                      l.steps.forEach((s, sI) => {
                        // add mode icons
                        let icon = (s.transit) ?
                                      modeIcons.find(mode => mode.googleKey === s.transit.line.vehicle.type) :
                                      modeIcons.find(mode => mode.googleKey === s.travel_mode)
                        if (icon) {
                          response.routes[rI].legs[lI].steps[sI].icon = icon
                        }

                      })

                    })
                  })
                  console.log(response.routes[0].legs[0])
                  commit('SET_TRIP_RESULTS_ROUTES', response.routes)
                } else {
                  // window.alert('Directions request failed due to ' + status);
                }
              })
    })
    // commit('SET_LOADING', { bool: true, prop: 'serviceAlerts' })
  },
}

// this must match what is in router/trip-planner.js
function getRouter (state) {
  function getUrlParams (state) {
    return {
      startName: state.inputs.origin.name.split('/').join(' '),
      startLat: state.inputs.origin.lat,
      startLng: state.inputs.origin.lng,
      finishName: state.inputs.destination.name.split('/').join(' '),
      finishLat: state.inputs.destination.lat,
      finishLng: state.inputs.destination.lng,
      date: state.inputs.when.date,
      time: state.inputs.when.time,
      // deparr: (state.inputs.when.type === 'now' || state.inputs.when.type === 'depart') ? 'depart' : 'arrive'
      deparr: state.inputs.when.type
    }
  }
  function getUrlQuery (state) {
    let result = {
      time_zone: settings.DATETIME.TIME_ZONE,
      alternatives: (state.inputs.options.alternatives) ? state.inputs.options.alternatives : true,
      units: (state.inputs.options.units) ? state.inputs.options.units : 'imperial',
      transit_routing_preference: (state.inputs.options.transit_routing_preference != 'best_route') ? state.inputs.options.transit_routing_preference : '',
    }
    if (state.inputs.options.optimize) {
      result.optimize = state.inputs.options.optimize
    }
    if (state.inputs.options.mode) {
      result.mode = state.inputs.options.mode
    }
    if (state.inputs.options.transit_mode) {
      result.transit_mode = state.inputs.options.transit_mode
    }
    if (state.compareFutureCurrent) {
      result.compareFutureCurrent = 1
    }
    return result
  }

  return {params: getUrlParams(state), query: getUrlQuery(state)}
}

function getDirectionsGoogleOptions (state) {
  let router = getRouter(state)
  let options = {
    origin: { lat: router.params.startLat, lng: router.params.startLng },
    destination: { lat: router.params.finishLat, lng: router.params.finishLng },
    provideRouteAlternatives: true
  }
  if (router.query.transit_mode) {
    options.travelMode = 'transit'.toUpperCase()
    options.transitOptions = {
      modes: router.query.transit_mode.toUpperCase().split("|")
    }
    if (router.query.deparr === 'depart' || router.query.deparr === 'now') {
      options.transitOptions.departureTime = moment(router.params.date+'T'+router.params.time).toDate()
    } else {
      options.transitOptions.arrivalTime = moment(router.params.date+'T'+router.params.time).toDate()
    }
  } else if (router.query.mode) {
    if (router.query.mode === 'bicycling') {
      options.travelMode = router.query.mode.toUpperCase()
    }
  }
  return options
}

// http://dev.opentripplanner.org/apidoc/0.20.0/resource_PlannerResource.html
function getTripsOTPOptions (state) {
  let router = getRouter(state)
  let options = {
    date: router.params.date,
    mode: router.query.mode,
    time: router.params.time,
    fromPlace: router.params.startLat +','+router.params.startLng,
    toPlace: router.params.finishLat +','+router.params.finishLng,
    numItineraries: 3,
    maxWalkDistance: 1000,
    bikeSpeed: 4.9,
    walkReluctance: 0,
    maxTransfers: 5,
    triangleSlopeFactor: 0.5,
    triangleSafetyFactor: 0.5,
    triangleTimeFactor: 0,
    optimize: (router.query.optimize) ? router.query.optimize : 'QUICK',
    showIntermediateStops: true,
    arriveBy: ((router.query.deparr === 'arrive') ? true : false )
  }

  return options
}

// Getters are a way to grab computed data from the store
const getters = {
  stage               : state => state.stage,
  map                 : state => state.map,
  inputs              : state => state.inputs,
  ajax                : state => state.ajax,
  router              : state => getRouter(state),
  directionsOptions   : state => getDirectionsGoogleOptions(state),
  tripMeta            : state => (state.resultsViewActive === 'current') ? state.resultsCurrent.meta : state.resultsFuture.meta,
  tripSummary         : state => (state.resultsViewActive === 'current') ? state.resultsCurrent.summary: state.resultsFuture.summary,
  tripRoutes          : state => (state.resultsViewActive === 'current') ? state.resultsCurrent.routes: state.resultsFuture.routes,
  selectedTripIndex   : state => (state.resultsViewActive === 'current') ? state.resultsCurrent.selectedTripIndex: state.resultsFuture.selectedTripIndex,
  selectedLegIndex    : state => (state.resultsViewActive === 'current') ? state.resultsCurrent.selectedLegIndex: state.resultsFuture.selectedLegIndex,
  selectedLegIsLast   : state => (state.resultsViewActive === 'current') ? state.resultsCurrent.selectedLegIsLast: state.resultsFuture.selectedLegIsLast,
  setMapBounds        : state => (state.resultsViewActive === 'current') ? state.resultsCurrent.setMapBounds: state.resultsFuture.setMapBounds,
  currentTripData     : state => state.currentTripData,
  futureTripData      : state => state.futureTripData,
  compareFutureCurrent: state => state.compareFutureCurrent,
  resultsViewActive  : state => state.resultsViewActive,
 }

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/trip-planner.js